import React from "react";
import ServicesSection from "../pages/ServicesSection";
import FactsNumberSection from "../pages/FactsNumberSection";
import WhyChooseSection from "../pages/WhyChooseSection";
import AboutTestimonials from "../pages/AboutTestimonials";
import VisionMission from "../pages/VisionMission";

const AboutSection = () => {
  return (
   <>
       <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title">About us</h2>
           
          </div>
        </div>
      </div>
    </div>


   
    <section className="section about-sec">
      <div className="container">
        <div className="row align-items-center">
          
          {/* Image Section */}
          <div className="col-lg-6" data-aos="fade-down">
            <div className="about-img">
              <div className="about-exp">
                {/* <span>12+ years of experiences</span> */}
              </div>
              <div className="abt-img">
                <img
                  src="/images/bg.png"
                  className="img-fluid"
                  alt="About us"
                />
              </div>
            </div>
          </div>

          {/* Content Section */}
        <div className="col-lg-6" data-aos="fade-down">
  <div className="about-content">
    <h6>ABOUT OUR COMPANY</h6>
    <h2>Reliable & Affordable Cab Services</h2>
    <p>
  SRS Cab Service, founded in 2006 and owned by Mr. Shankar Suryvanshi, is dedicated to providing safe, comfortable, and reliable transportation solutions for all your travel needs. With years of experience in the industry, we have built a strong reputation for quality service and customer trust. Whether you need a quick ride within the city or a long-distance journey, we ensure a smooth and hassle-free experience with our well-maintained vehicles and professional drivers.
</p>
<p>
  Our mission is to deliver timely service, transparent pricing, and customer satisfaction at every step. With a focus on convenience and safety, SRS Cab Service has become a trusted choice for daily commuters, tourists, and business travelers alike.
</p>
    <div className="row">
      {/* <div className="col-md-6">
        <ul>
          <li>Experienced and professional drivers</li>
          <li>24/7 customer support service</li>
        </ul>
      </div> */}
      {/* <div className="col-md-6">
        <ul>
          <li>Affordable and transparent pricing</li>
          <li>Clean, comfortable, and safe rides</li>
        </ul>
      </div> */}
    </div>
  </div>
</div>

        </div>
      </div>
    </section>
   
   <ServicesSection/>
   <VisionMission/>
   {/* <FactsNumberSection/> */}
   <WhyChooseSection/>
   <AboutTestimonials/>
   
   </>
  );
};

export default AboutSection;